<template>
  <el-container class="creator-center">
    <el-header class="header">
      <CreatorHeader />
    </el-header>
    <el-container>
      <div class="main-container">
        <CreatorSidebar />
        <div class="right-wrap">
          <div class="main-content">
            <div class="tab-nav">
              <div class="leftitem">
                <el-tabs v-model="activeTab">
                  <el-tab-pane
                    label="数据概览"
                    name="all"
                    style="font-size: 18px">
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div class="card-box">
              <div class="card-tab">
                <div class="label">
                  <span class="label-text">最近30天新增文章
                  </span>
                </div>
                <div class="datafix">{{ articleinfo.articleLastCount }}</div>
                <div class="button-box">
                  <span class="text">总计<span class="text-num">{{ articleinfo.articleCount }}</span>篇文章</span>
                </div>
              </div>
              
            </div>
            
          </div>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";
import axiosInstance from "@/utils/axiosInstance";

const activeTab = ref<string>("all");

const SSRData = ref({
  title: "创作者中心 - " + WebSite_Name,
  description:
    "默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

const articleinfo = ref({
  articleCount: 0,
  articleLastCount: 0
});

onMounted(() => {
  activeTab.value = "all";
  fetchArticleStatistics();
});


// 文章统计
const fetchArticleStatistics = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/ArticleInfo/GetArticleStatistics",
      {
        params: {
        },
      }
    );
    var result = response.data;
    if (result.success) {
      articleinfo.value.articleCount = result.data.TotalCount;
      articleinfo.value.articleLastCount = result.data.Last30DaysCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};

</script>

<style scoped>
.creator-center {
  width: 100%;
  height: 100%;
}
.header {
  justify-content: space-between;
  padding: 0 20px;
  background: #fff;
  transform: translateZ(0);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: transform 0.2s;
  z-index: 250;
}
.main-container {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  margin-top: 22px;
}

.right-wrap {
  width: 980px;
  margin-left: 220px;
}

.main-content {
  min-height: calc(100vh - 108px);
  margin-bottom: 24px;
  padding: 0 20px;
  background: #fff;
  margin-top: 59px;
}

.tab-nav {
  position: relative;
  margin-bottom: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
}
.leftitem {
  position: relative;
  z-index: 1;
  float: left;
  white-space: nowrap;
  width: 200px;
}
.el-tabs {
  --el-tabs-header-height: 56px !important;
  line-height: 56px !important;
  vertical-align: top !important;
  margin-bottom: 0px 0px 0px 0px !important;
}

.leftitem ::v-deep .el-tabs__header {
  margin-bottom: 0px;
}
.leftitem ::v-deep .el-tabs__item {
  font-size: 16px;
}
.leftitem ::v-deep .el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #cc5656;
}
.leftitem ::v-deep .el-tabs__active-bar {
  background-color: #cc5656;
}
.rightitem {
  display: flex;
  align-items: center;
}
.search-input {
  width: 240px;
}

.card-box {
  margin:0 20px;
  display:flex;
  flex-flow:row wrap
}

.card-box .card-tab:nth-child(3n) {
  margin-right:0
}
.card-tab {
  width:calc(33.33333% - 13.33333px);
  margin-right:20px;
  margin-bottom:20px;
  box-sizing:border-box;
  padding:16px 20px;
  background:#f3f1ef;
  height:-webkit-fit-content;
  height:-moz-fit-content;
  height:fit-content;
  border-radius:2px
}

.card-tab .label {
  align-items:center;
  color:#949291;
  font-size:16px;
  line-height:22px;
  margin-bottom:4px;
  text-align: center;
}
.card-tab .label .label-text {
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

.card-tab .datafix {
  color:#1d2129;
  font-weight:600;
  font-size:32px;
  line-height:42px;
  margin-bottom:4px;
  white-space:nowrap;
  text-align: center;
}
.card-tab .button-box {
  align-items:center;
  height:22px;
  text-align: center;
}
.card-tab .button-box .text {
  color:#a9a7a6;
  font-size:16px;
  white-space:nowrap;
}

.card-tab .text-num {
  color:#3a3b38;
  font-weight:600;
  font-size:16px;
  line-height:42px;
  margin-bottom:4px;
  white-space:nowrap;
  text-align: center;
  padding: 0 5px;
}
</style>
